export default {
    easeOut: function(time, start, change, duration) {
        return start + change * Math.sin(Math.min(1, time / duration) * (Math.PI / 2));
    },

    scrollTo: function(element, newPos, duration) {
        var startTime = Date.now();
        var startPos = element.scrollTop;
        var self = this;

        // Don't try to scroll beyond the limits. You won't get there and this will loop forever.
        newPos = Math.max(0, newPos);
        newPos = Math.min(element.scrollHeight - element.clientHeight, newPos);
        var change = newPos - startPos;

        // This inner function is called until the elements scrollTop reaches newPos.
        var updateScroll = function() {
            var now = Date.now();
            var time = now - startTime;
            element.scrollTop = self.easeOut(time, startPos, change, duration);
            if (element.scrollTop !== newPos) {
                requestAnimationFrame(updateScroll, element);
            }
        };
        requestAnimationFrame(updateScroll, element);
    },


    scrollToElement: function(element) {
        var parent = element.parentElement;
        var parentOffsetBottom = parent.offsetTop + parent.clientHeight;
        var elementOffsetBottom = element.offsetTop + element.clientHeight;
        var relTop = element.offsetTop - parent.offsetTop;
        var relBottom = (element.offsetTop + element.clientHeight) - parent.offsetTop;
        var centerPosCorrection = 100;
        var newPos;
        // If the top of the line is above the top of the parent view, were scrolling up,
        // so we want to move the top of the element downwards to match the top of the parent.
        if (relTop < parent.scrollTop + centerPosCorrection) {
            newPos = element.offsetTop - parent.offsetTop - centerPosCorrection;

            // If the bottom of the line is below the parent view, we're scrolling down, so we want the
            // bottom edge of the line to move up to meet the bottom edge of the parent.
        } else if (relBottom >= (parent.scrollTop + parent.clientHeight) - centerPosCorrection) {
            newPos = elementOffsetBottom - parentOffsetBottom + centerPosCorrection;
        }
        // Don't try to scroll if we haven't set a new position.  If we didn't
        // set a new position the line is already in view (i.e. It's not above
        // or below the view)
        // And don't try to scroll when the element is already in position.
        if (newPos !== undefined && parent.scrollTop !== newPos) {
            this.scrollTo.call(this, parent, newPos, 400);
        }
    }
}



// WEBPACK FOOTER //
// ./src/packages/animation/index.js